var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { ref: "print" },
      [
        _c("p", {
          staticStyle: { "text-align": "center", "font-size": "25px" }
        }),
        _c(
          "el-row",
          { staticStyle: { margin: "10px" }, attrs: { type: "fixed" } },
          [
            _c("el-col", { attrs: { span: 6 } }, [
              _vm._v("姓名：" + _vm._s(_vm.item.areaName))
            ]),
            _c("el-col", { attrs: { span: 6 } }, [
              _vm._v("房间号: " + _vm._s(_vm.item.nowDate))
            ]),
            _c("el-col", { attrs: { span: 6 } }, [
              _vm._v("付款方式: " + _vm._s(_vm.item.nowDate))
            ]),
            _c("el-col", { attrs: { span: 6 } }, [
              _vm._v("付款时间: " + _vm._s(_vm.item.nowDate))
            ])
          ],
          1
        ),
        _c(
          "table",
          {
            staticClass: "cfdDiv",
            staticStyle: { width: "100%" },
            attrs: { border: "1", cellspacing: "0", cellpadding: "0" }
          },
          [
            _vm._m(0),
            _vm._l(_vm.item.detialList, function(n, index) {
              return _c("tr", { key: index, staticClass: "cfdContent" }, [
                _c("td", [_vm._v(_vm._s(n.chargeStandardName))]),
                _c("td", [_vm._v(_vm._s(n.houseArea))]),
                _c("td", [_vm._v(_vm._s(n.lastReadData))]),
                _c("td", [_vm._v(_vm._s(n.currentReadData))]),
                _c("td", [_vm._v(_vm._s(n.usedNum))]),
                _c("td", [_vm._v("¥" + _vm._s(n.priceUnit))]),
                _c("td", [_vm._v("¥" + _vm._s(n.unpaidAmount))]),
                _c("td", [_vm._v("¥" + _vm._s(n.unpaidAmountBefor))]),
                _c("td", [_vm._v("¥" + _vm._s(n.receivableLateAmount))]),
                _c("td")
              ])
            }),
            _c("tr", { staticClass: "cfdContent" }, [
              _c(
                "td",
                {
                  staticStyle: { "text-align": "left" },
                  attrs: { colspan: "6" }
                },
                [_vm._v("合计金额小写：")]
              ),
              _c("td", [_vm._v("¥" + _vm._s(_vm.item.monthFeeTotal))]),
              _c("td", [_vm._v("¥" + _vm._s(_vm.item.historyFeeTotal))]),
              _c("td", [
                _vm._v("¥" + _vm._s(_vm.item.receivableLateAmountTotal))
              ]),
              _c("td", [_vm._v("¥" + _vm._s(_vm.item.feeTotal))])
            ]),
            _c("tr", { staticClass: "cfdContent" }, [
              _c(
                "td",
                {
                  staticStyle: { "text-align": "left" },
                  attrs: { colspan: "2" }
                },
                [_vm._v("合计金额大写：")]
              ),
              _c(
                "td",
                {
                  staticStyle: { "text-align": "right" },
                  attrs: { colspan: "8" }
                },
                [_vm._v(_vm._s(_vm.numberChinese(_vm.item.feeTotal)))]
              )
            ])
          ],
          2
        ),
        _vm._m(1),
        _c("div", [
          _vm._v(
            "本收据不作为报销凭证,盖章有效,妥善报错,遗失不补。(白-客户 红-记账 黄-存根)"
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("收费项目")]),
      _c("th", [_vm._v("起始日期")]),
      _c("th", [_vm._v("截止日期")]),
      _c("th", [_vm._v("面积")]),
      _c("th", [_vm._v("上期读数")]),
      _c("th", [_vm._v("本期读数")]),
      _c("th", [_vm._v("用量")]),
      _c("th", [_vm._v("单价")]),
      _c("th", [_vm._v("应收金额")]),
      _c("th", [_vm._v("减免金额")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", [_vm._v("实收金额："), _c("span", [_vm._v("￥1101.11")])]),
      _c("div", [
        _vm._v("实收金额人民币(大写)："),
        _c("span", [_vm._v("壹佰零四圆")])
      ]),
      _c("div", [_vm._v("收款人："), _c("span", [_vm._v("专业版")])])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }